import Typography from "@mui/material/Typography";

export default Typography;
